"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedDispatchContext = exports.AuthenticatedAppContext = exports.AuthenticatedAppStateProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var AuthenticatedAppContextState_1 = require("./AuthenticatedAppContextState");
var AuthenticatedAppContext = (0, react_1.createContext)(undefined);
exports.AuthenticatedAppContext = AuthenticatedAppContext;
var AuthenticatedDispatchContext = (0, react_1.createContext)(undefined);
exports.AuthenticatedDispatchContext = AuthenticatedDispatchContext;
var AuthenticatedAppStateProvider = function (_a) {
    var 
    // @ts-ignore
    children = _a.children, _b = _a.initialValue, initialValue = _b === void 0 ? new AuthenticatedAppContextState_1.AuthenticatedAppContextState() : _b;
    var _c = (0, react_1.useState)(initialValue), state = _c[0], setState = _c[1];
    return ((0, jsx_runtime_1.jsx)(AuthenticatedAppContext.Provider, { value: state, children: (0, jsx_runtime_1.jsx)(AuthenticatedDispatchContext.Provider, { value: setState, children: children }) }));
};
exports.AuthenticatedAppStateProvider = AuthenticatedAppStateProvider;
